import React from 'react';
import './Editable.css';
import {Editable, EditableProps} from "./Editable";
import {useEditable} from "./EditableContext";

type Props<EnclosingType extends object> = EditableProps<EnclosingType, string> & {
  maxCharacterCount?: number,
}

export const EditableLongTextField = <EnclosingType extends object>(props: Props<EnclosingType>) => {

  const {editing, value, setValue} = useEditable(props);

  return <Editable {...props}>
    {editing && <textarea className={'EditableEditing'}
                          value={value ?? undefined}
                          maxLength={props.maxCharacterCount}
                          rows={4}
                          onChange={event => setValue(event.target.value)}
    />}

    {!editing && <div className={'EditableNotEditing'}>
      {value}
    </div>}
  </Editable>
}